import { getApplicationDomain } from '../constants/apiEnvironments';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
export const getCommerceRedirect = state => {
  const portalId = getPortalId(state);
  const hublet = getHublet(state);
  return `${getApplicationDomain(hublet)}/commerce/${portalId}`;
};